import React from 'react';
import Header from '../../components/header/Header';

const Dashboard: React.FC = () => {
  return <Header />;
};

export default Dashboard;
